module.exports = __webpack_public_path__ + "img/web_03.932efeb6.png";